export default __webpack_public_path__ + "static/media/icon-ic-pin.468c145c.svg";